import { Badges, H5, H6, P } from "../../../../AbstractElements";
import { AppIdeas } from "../../../../Constants/Constants";

const AppIdeasTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-picture bg-primary">
        <i className="icon-pencil-alt" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="warning">{AppIdeas}</Badges>
        </div>
        <H5 className="m-0">{"Established new the app-ideas repository."}</H5>
        <P className="mb-0">{"developers who are just beginning their learning process. those who often concentrate on developing programmes with a user interface."}</P>
        <div className="time-content pt-2 d-flex">
          <i className="icon-github me-2"></i>
          <H6>{"View it on Github"} </H6>
        </div>
        <span className="cd-date">February 02 2024</span>
      </div>
    </div>
  );
};
export default AppIdeasTimeline;
